import type { PricingList } from 'api/types/pricing.types';
import Accordion from 'components/molecules/Accordion';
import React, { useMemo } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDisableLinens } from 'store/cart-estimator';

import AddItemRow from './addItemRow';
import HintItem from './pricing-more-sheets/hint-item';

interface Props {
  list: PricingList.ItemCategory[];
  currency?: string;
  serviceType: PricingList.ServiceTypes;
}

const Collapsible: React.FC<Props> = ({ list, currency, serviceType }) => {
  const isDisabled = useDisableLinens();

  const sortedList = useMemo(
    () =>
      list.map((category) => ({
        ...category,
        itemTypes: category.itemTypes.sort((a, b) => {
          if (a.discountedPrice && b.discountedPrice) {
            return a.discountedPrice - b.discountedPrice;
          }
          if (a.discountedPrice) {
            return -1;
          }
          if (b.discountedPrice) {
            return 1;
          }
          return 0;
        }),
      })),
    [list]
  );

  return (
    <Row className="h-100">
      <Col xs={12} className="h-100 overflow-auto px-0">
        {sortedList.map(
          (category, i) =>
            category.itemTypes.length > 0 && (
              <Accordion isDefaultExpanded={i === 0} key={category.key} title={category.name}>
                {category.hintItem && <HintItem hintItem={category.hintItem} />}
                {category.itemTypes.map((item) => (
                  <AddItemRow
                    key={`${serviceType}-${item.key}`}
                    data={item}
                    currency={currency}
                    serviceType={serviceType}
                    isAddButtonDisabled={category.key === 'LINEN' && isDisabled}
                    category={category.key}
                  />
                ))}
              </Accordion>
            )
        )}
      </Col>
    </Row>
  );
};

export default Collapsible;
